import { createApp } from 'vue'
import App from './App.vue'
import './assets/scss/app.scss'

import 'swiper'

createApp(App).mount('#app')
